import { font, colors } from '../../config/theme'
import { width100 } from '../../utils/jss-utils'

const style = {}

style.base = {
  ...width100,
  height: '40px !important',
  display: 'block',
  font: {
    size: '28px !important',
    weight: '100'
  },
  marginBottom: '10px',
  paddingLeft: '3px'
}

style.underline = {
  transition: 'border .3s',
  border: `1px solid ${colors.lightGray}`,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  backgroundColor: 'transparent',
  '&:focus': {
    border: `1px solid ${colors.black}`,
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none'
  }
}

style.full = {
  border: `1px solid ${colors.black}`
}

export default style
